import { createContext, useContext, useState } from "react";

import { IUser, IUserProps } from "interfaces/User";

import {
  ContextProviderProps,
  FormError,
  UserContextData,
} from "./IUserContext";
import { IScheduleSubmitProps } from "interfaces/Schedule";
import { getUserService } from "services/UserServices";

export const UserContext = createContext({} as UserContextData);

export function UserRegisterProvider({
  children,
}: ContextProviderProps): JSX.Element {
  const [user, setUser] = useState<IUserProps>({} as IUserProps);
  const [schedule, setSchedule] = useState<IScheduleSubmitProps>(
    {} as IScheduleSubmitProps
  );

  const [errors, setErrors] = useState<FormError>({});
  const [searching, setSearching] = useState<boolean>(false);
  async function retrieveUser(id: string) {
    setSearching(true);
    await getUserService({ where: { id } })
      .then((res) => {
        const _user = {
          cpf: res.item.cpf,
          email: res.item.email,
          id: res.item.id,
          name: res.item.name,
          rg: res.item.rg,
          role: res.item.role.id,
          type: res.item.type,
          password: res.item.password || "",
        };
        if (res.item.schedule) {
          const _schedule = {
            id: res.item.schedule.id,
            mondayEntry: new Date(res.item.schedule.mondayEntry),
            mondayExit: new Date(res.item.schedule.mondayExit),
            tuesdayEntry: new Date(res.item.schedule.tuesdayEntry),
            tuesdayExit: new Date(res.item.schedule.tuesdayExit),
            wednesdayEntry: new Date(res.item.schedule.wednesdayEntry),
            wednesdayExit: new Date(res.item.schedule.wednesdayExit),
            thursdayEntry: new Date(res.item.schedule.thursdayEntry),
            thursdayExit: new Date(res.item.schedule.thursdayExit),
            fridayEntry: new Date(res.item.schedule.fridayEntry),
            fridayExit: new Date(res.item.schedule.fridayExit),
            saturdayEntry: new Date(res.item.schedule.saturdayEntry),
            saturdayExit: new Date(res.item.schedule.saturdayExit),
            sundayEntry: new Date(res.item.schedule.sundayEntry),
            sundayExit: new Date(res.item.schedule.sundayExit),
          };
          setSchedule(_schedule);
        }
        setUser(_user);
        setSearching(false);
      })
      .catch((err) => {
        setSearching(false);
      });
  }

  function resetUser() {
    setSearching(true);
    setUser({} as IUserProps);
    setSchedule({} as IScheduleSubmitProps);

    setSearching(false);
  }

  function addError(field: string, message: string) {
    const _errors = { ...errors };
    _errors[field] = message;

    setErrors(() => {
      return _errors;
    });
  }

  function removeError(field: string) {
    const _errors = { ...errors };
    delete _errors[field];

    setErrors(() => {
      return _errors;
    });
  }

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        errors,
        setErrors,
        addError,
        removeError,
        retrieveUser,
        resetUser,
        searching,
        schedule,
        setSchedule,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export const useUserRegister = () => {
  return useContext(UserContext);
};
